(function() {

	$(document).ready(() => {
		$('.content p').has('img.alignnone').addClass('has-full-img');
	});

})();